export default __webpack_public_path__ + "static/media/Home.82884c2d.svg";